export default (theme) => ({
  root: {
    height: "calc(var(--vh, 1vh) * 100)",
    display: "flex",
  },
});
